import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '../../../elements';
import { Headline, Paragraph } from '../../../elements/Typography';
import { IconAnimation } from '../../../elements/Icon/Animation';
export const Circle = styled.div `
  width: 68px;
  height: 68px;
  border-radius: 50%;
  margin: 24px auto 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, $type }) => theme[$type ?? 'primary'].blendToBackground(1000, 100)};
  --icon-color: ${({ theme, $type }) => theme[$type ?? 'primary'].background};

  svg {
    --icon-size: 30px;
    --icon-color: ${({ theme, $type }) => theme[$type ?? 'primary'].background};
  }
`;
export const IconCircle = ({ type, icon, children }) => {
    const IconComponent = icon && typeof Icon[icon] === 'function' ? Icon[icon] : undefined;
    const styleProps = { $type: type };
    return React.createElement(Circle, { ...styleProps }, IconComponent ? React.createElement(IconComponent, null) : children);
};
export const AnimatedIconCircle = ({ type, icon, children, onDone, running, }) => {
    const IconComponent = icon && typeof IconAnimation[icon] === 'function' ? Icon[icon] : undefined;
    const styleProps = { $type: type };
    return (React.createElement(Circle, { ...styleProps }, IconComponent ? React.createElement(IconComponent, { onDone: onDone, running: running }) : children));
};
export const Inner = styled.div `
  display: grid;
`;
const ContentWrapper = styled.div ``;
const ContentInner = styled.div `
  display: grid;
  grid-gap: 8px;
  padding: 0 var(--page-margin);
  margin: 0 auto;
  box-sizing: border-box;
  text-align: ${({ $align }) => $align ?? 'center'};
  max-width: ${({ $maxWidth }) => $maxWidth ?? '100%'};
`;
export const Content = ({ beforeContent, children, align, maxWidth }) => {
    const styleProps = { $align: align, $maxWidth: maxWidth };
    return (React.createElement(ContentWrapper, null,
        beforeContent,
        React.createElement(ContentInner, { ...styleProps }, children)));
};
const HeaderWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px var(--page-margin);
  border-bottom: ${({ $noBorder, theme }) => $noBorder ? 'none' : `1px solid ${theme.secondary.blendToBackground(150)}`};
`;
export const Header = ({ title, children, noBorder = false }) => {
    return (React.createElement(HeaderWrapper, { "$noBorder": noBorder },
        React.createElement(Headline, null, title),
        children));
};
export const Footer = styled.div `
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0;
  padding: var(--page-margin);
  box-sizing: border-box;
  border-radius: 0 0 12px 12px;

  ${({ $withBackground, theme }) => $withBackground &&
    css `
      background-color: ${theme.secondary.blendToBackground(25)};
      border-top: 1px solid ${theme.secondary.blendToBackground(150)};

      ${() => theme.id !== 'default' &&
        css `
          background-color: ${theme.body};
          border-top: 1px solid ${theme.secondary.blendToBackground(50)};
        `}
    `}
`;
export const Group = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export { Headline, Paragraph };
//# sourceMappingURL=Content.js.map